import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import { encode64, formatFormData } from 'utils/ebUtils';
import * as actionTypes from '../actions/actionTypes';
import * as locationActions from '../actions/locationActions';
import qs from 'qs'

const formatAddressParams = (address, update) => {
  const data = { rs: encode64(JSON.stringify(address)) };
  data.update = update;
  return data;
};

const getExpParams = (contactId) => {
  return {
    orgId: orgId,
    contactId: contactId,
    _search: false,
    pageSize: 5,
    pageNo: 1,
    sidx: 'address.arriveDate',
    sord: 'desc'
}
}

export function* fetchStatesAndCountries() {
  try {
    const url = '/rest/registration/statesAndCountries';
    const { data: result } = yield call(Ajax.get, url);
    const countries = _.get(result, 'countries', []);
    const states = _.get(result, 'states', []);
    const payload = {
      countries,
      states,
    };
    yield put(locationActions.fetchStatesAndCountries.success(payload));
  } catch (error) {
    yield put(locationActions.fetchStatesAndCountries.fail(error));
  }
}

export function* watchFetchStatesAndCountries() {
  yield takeLatest(actionTypes.FETCH_STATES_AND_COUNTRIES.ACTION, fetchStatesAndCountries);
}

export function* fetchGeocodingAddresses({
  payload: { addressGeoCodingSource, queryAddress, callback },
}) {
  try {
    const url = '/getgeo/json';
    const formData = formatFormData({
      orgId,
      rs: encode64(JSON.stringify(queryAddress)),
    });
    const { data: result } = yield call(Ajax.post, url, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    let geocodingAddresses = [];
    if (_.isArray(result)) {
      const character = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      geocodingAddresses = result.map((item, index) => {
        const {
          formattedAddress,
          addressLine,
          country,
          suite,
          postalCode,
          latitude: lat,
          longitude: lon,
          locality,
          adminDistrict,
        } = item;
        const title = character.charAt(index);
        //const streetAddress = formattedAddress || addressLine;
        const streetAddress = addressLine || formattedAddress;
        const addressName = `${title} - ${streetAddress} ${country}`;
        const suggestionAddress = `${addressLine} ${locality === null ? '' : locality} ${country}`;
        const position = { lat, lng: lon };
        const active = index === 0;
        const city = locality === null ? '' : locality;

        return {
          suggestionAddress,
          streetAddress,
          addressName,
          country,
          position,
          title,
          active,
          suite: suite || '',
          postalCode: postalCode || '',
          lon,
          lat,
          addressGeoCodingSource,
          city,
          adminDistrict,
        };
      });
    }
    yield put(
      locationActions.fetchGeocodingAddresses.success({
        geocodingAddresses,
      }),
    );

    if (callback) {
      callback();
    }
  } catch (error) {
    yield put(locationActions.fetchGeocodingAddresses.fail(error));
  }
}

export function* watchFetchGeocodingAddresses() {
  yield takeLatest(actionTypes.FETCH_GEOCODING_ADDRESSES.ACTION, fetchGeocodingAddresses);
}

export function* saveGeocodingAddress({ payload: { address } }) {
  try {
    const { lat, lng: lon } = address.position;
    const { successCallBack, failCallBack } = address;
    const rs = encode64(JSON.stringify({ lat, lon }));
    const url = `/rest/registration/checkGeoFenceAddress?orgId=${orgId}&rs=${rs}`;
    const { status, data } = yield call(Ajax.post, url, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    if (status === 200) {
      if (!data.geoFenceStatus) {
        successCallBack();
      } else {
        failCallBack();
      }
    } else {
      yield put(
        locationActions.saveGeocodingAddress.fail({
          status,
        }),
      );
    }
  } catch (error) {
    yield put(locationActions.saveGeocodingAddress.fail(error));
  }
}

export function* watchSaveGeocodingAddress() {
  yield takeLatest(actionTypes.SAVE_GEOCODING_ADDRESS.ACTION, saveGeocodingAddress);
}

export function* getLocationList({ payload: { contactId } }) {
  try {
    const url = `/${orgId}/${contactId}/addresses`;
    const { data: result } = yield call(Ajax.get, url);
    const countries = _.get(result, 'countries', []);
    const states = _.get(result, 'states', []);
    const addresses = _.get(result, 'addresses', []);
    const editable = _.get(result, 'editable', []);
    const expose = _.get(result, 'expose', []);
    const exposeExpLoc = _.get(result, 'exposeExpLoc', []);
    const editableExpLoc = _.get(result, 'editableExpLoc', []);
    const geocodingType = _.get(result, 'geocodingType', []);
    const defaultAddressGeoCodingSource = _.get(result, 'defaultAddressGeoCodingSource', []);
    const payload = {
      countries,
      addresses,
      editable,
      expose,
      geocodingType,
      defaultAddressGeoCodingSource,
      states,
      exposeExpLoc,
      editableExpLoc,
    };
    yield put(locationActions.getLocationList.success(payload));
  } catch (error) {
    yield put(locationActions.getLocationList.fail(error));
  }
}

export function* watchGetLocationList() {
  yield takeLatest(actionTypes.GET_LOCATION_LIST.ACTION, getLocationList);
}

export function* saveOrUpdateLocations({
  payload: { contactId, address, update, successCallback, failCallback }
}) {
  try {
    console.log(address,"address", update, "update");
    const addressParams = formatAddressParams(address, update);
    const formattedParams = formatFormData(addressParams);
    const url = `/${orgId}/${contactId}/addresses`;
    const { data: result } = yield call(Ajax.post, url, formattedParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const addOrEditStatus = _.get(result, 'status', '');
    const payload = {
      addOrEditStatus,
    };
    if (addOrEditStatus === '1') {
      yield put(locationActions.getLocationList.action({ contactId }));
      _.attempt(successCallback, { message: 'ssp.save.success', success: true });
    } else {
      _.attempt(failCallback, {
        message: 'ssp.register.saveProfile.fail',
        success: false,
      });
    }
    yield put(locationActions.saveOrUpdateLocations.success(payload));
  } catch (error) {
    yield put(locationActions.saveOrUpdateLocations.fail(error));
  }
}

export function* watchSaveOrUpdateLocations() {
  yield takeLatest(actionTypes.SAVE_OR_UPDATE_LOCATION.ACTION, saveOrUpdateLocations);
}

export function* deleteLocation({ payload: { contactId, data } }) {
  try {
    const formData = formatFormData({
      _method: 'DELETE',
      name: data.name,
    });
    const url = `/${orgId}/${contactId}/addresses`;
    const { data: result } = yield call(Ajax.post, url, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const { success } = data;
    const status = _.get(result, 'status', '');
    const payload = {
      status,
    };
    yield put(locationActions.deleteLocation.success(payload));
    if (status === '1') {
      success();
      yield put(locationActions.getLocationList.action({ contactId }, () => { }));
    }
  } catch (error) {
    yield put(locationActions.deleteLocation.fail(error));
  }
}

export function* watchDeleteLocation() {
  yield takeLatest(actionTypes.DELETE_LOCATION.ACTION, deleteLocation);
}

export function* getExpectedLocationList({ payload: { contactId, params } }) {
  try {
    const url = `/${orgId}/${contactId}/addresses/expectedLocations`;
    const { data: result } = yield call(Ajax.post, url, qs.stringify(params), {
             headers: {
               'Content-Type': 'application/x-www-form-urlencoded',
             },
           });
    const expectedLocations = result
    const payload = {
      //data,
      expectedLocations,
    };
    yield put(locationActions.getExpectedLocationList.success(payload));
  } catch (error) {
    yield put(locationActions.getExpectedLocationList.fail(error));
  }
}

export function* watchGetExpectedLocationList() {
  yield takeLatest(actionTypes.GET_EXPECTED_LOCATION_LIST.ACTION, getExpectedLocationList);
}

export function* saveOrUpdateExpLoc({
  payload: { contactId, address, update, id, successCallback}
}) {
  try {
    const expLocParams = {
      contactId: contactId,
      address: address,
    }
    if(update){
      expLocParams.id = id;
    }
    
    const formattedParams = qs.stringify({ expectedLocation: JSON.stringify(expLocParams), update: update});
    const url = `/${orgId}/${contactId}/addresses/expectedLocation/createOrUpdate`;
    const { data: result } = yield call(Ajax.post, url, formattedParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const addOrEditStatus = _.get(result, 'status', '');
    const payload = {
      addOrEditStatus,
    };
     if (addOrEditStatus === '1') {
      const params = getExpParams(contactId)
       yield put(locationActions.getExpectedLocationList.action({ contactId, params}));
       _.attempt(successCallback, { message: 'ssp.save.success', success: true });
     } else {
       _.attempt(failCallback, {
         message: 'ssp.register.saveProfile.fail',
         success: false,
       });
     }
  } catch (error) {
  }
}

export function* watchSaveOrUpdateExpLoc() {
  yield takeLatest(actionTypes.SAVE_OR_UPDATE_EXPECTED_LOCATION.ACTION, saveOrUpdateExpLoc);
}

export function* deleteExpLocation({ payload: { contactId, data } }) {
  try {
    const formData = formatFormData({
      _method: 'DELETE',
      expectedLocationId: data.expectedLocationId,
    });
    const url = `/${orgId}/${contactId}/addresses/expectedLocation/delete`;
    const { data: result } = yield call(Ajax.post, url, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const { success } = data;
    const status = _.get(result, 'status', '');
    const payload = {
      status,
    };
    yield put(locationActions.deleteExpLocation.success(payload));
    if (status === '1') {
      success();
      const params = getExpParams(contactId)
      yield put(locationActions.getExpectedLocationList.action({ contactId, params}));
      
    }
  } catch (error) {
    yield put(locationActions.deleteExpLocation.fail(error));
  }
}

export function* watchDeleteExpLocation() {
  yield takeLatest(actionTypes.DELETE_EXP_LOCATION.ACTION, deleteExpLocation);
}
